import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Nav, Tab } from "react-bootstrap";
import Card from "../../../components/Card";

//img
import profilebg4 from "../../../assets/images/page-img/profile-bg4.jpg";

import user5 from "../../../assets/images/user/05.jpg";
import user6 from "../../../assets/images/user/06.jpg";
import user7 from "../../../assets/images/user/07.jpg";
import user8 from "../../../assets/images/user/08.jpg";
import user9 from "../../../assets/images/user/09.jpg";
import user10 from "../../../assets/images/user/10.jpg";
import user13 from "../../../assets/images/user/13.jpg";
import user14 from "../../../assets/images/user/14.jpg";
import user15 from "../../../assets/images/user/15.jpg";
import user16 from "../../../assets/images/user/16.jpg";
import user17 from "../../../assets/images/user/17.jpg";
import user18 from "../../../assets/images/user/18.jpg";
import user19 from "../../../assets/images/user/19.jpg";

//profile-header
import ProfileHeader from "../../../components/profile-header";
import { useDispatch, useSelector } from "react-redux";
import { fetchIgConversations } from "../../../store/instagram/instagramThunk";
import { fetchFBConversations } from "../../../store/facebook/facebookThunk";
import { getConversationList } from "../../../store/whatsApp/wpThunks";
import { userProfile } from "../../../store/user/userThunk";
import axios from "axios";

const Friendlist = () => {
  const { conversations, loading, conversationDetails, error, message } =
    useSelector((state) => state.instagram);
  let { profile } = useSelector((state) => state.userservice);
console.log(profile,"profileprofileprofileprofileprofileprofileprofileprofileprofile")
  const facebook = useSelector((state) => state.facebook);
  let whatsapp = useSelector((state) => state.whatsapp);

  let Fbconversations = facebook?.conversations;
  let Wpconversations = whatsapp?.conversations;
  console.log(conversations, "------------------conversations---------------");
  const [chats, setChats] = useState(null);

  let dispatch = useDispatch();

  let navigator = useNavigate();

  useEffect(() => {
    dispatch(userProfile());

    dispatch(fetchIgConversations());
    dispatch(fetchFBConversations());

    dispatch(getConversationList());


  }, []);
  useEffect(() => {
    setChats(conversations);
  }, [conversations]);
  // useEffect(() => {
  //   setChats(Fbconversations);
  // }, [Fbconversations]);

  let chatview = (platform) => {
    // if(platform=="facebook")
    //   {
    //     navigator('/chat/fbchat')

    //   }
    //   else if(platform=="instagram")
    //   {

    //
    //   }
    navigator(`/chat/${platform}`);
  };


  // gettype()
  return (
    <>
      <ProfileHeader title="Birthday" img={profilebg4} />
      <div id="content-page" className="content-inner">
        <Container>
          <Row>
            <Col sm="12">
              <div className="birthday-block">
                <Tab.Container defaultActiveKey= {profile?.iglogin == true?"instagram":profile?.iglogin==false && profile?.Fblogin==true?"facebook":profile?.iglogin==false && profile?.Fblogin==false && profile?.wpLogin==true?"whatsapp":null}>
                  <Nav
                    variant="pills"
                    className="mb-3 p-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    {profile?.iglogin == true ? (
                      <Nav.Item className="nav-item">
                        <Nav.Link
                          eventKey="instagram"
                          className="nav-link"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          href="#pills-home"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          instagram
                        </Nav.Link>
                      </Nav.Item>
                    ) : null}
                    {profile?.Fblogin == true ? (
                      <Nav.Item className="nav-item">
                        <Nav.Link
                          eventKey="facebook"
                          className="nav-link"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          // href="#pills-profile"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          facebook
                        </Nav.Link>
                      </Nav.Item>
                    ) : null}

                    {profile?.wpLogin == true ? (
                      <Nav.Item className="nav-item">
                        <Nav.Link
                          eventKey="whatsapp"
                          className="nav-link"
                          id="pills-contact-tab"
                          data-bs-toggle="pill"
                          role="tab"
                          aria-controls="pills-contact"
                          aria-selected="false"
                        >
                          whatsapp
                        </Nav.Link>
                      </Nav.Item>
                    ) : null}
                  </Nav>
                  <Tab.Content className="tab-content" id="pills-tabContent-2">
                    <Tab.Pane
                      eventKey="instagram"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <Card>
                        <Card.Header className="d-flex justify-content-between rounded border-bottom-0">
                          <div className="header-title">
                            <h4 className="card-title">instagram</h4>
                          </div>
                        </Card.Header>
                      </Card>

                      <Row>
                        {conversations?.map((chat) => {
                          return (
                            <Col lg="6" md="12">
                              <Card>
                                <Card.Body>
                                  <div className="iq-birthday-block">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <Link to="#">
                                          <img
                                            src={user5}
                                            alt="profile-img"
                                            className="img-fluid"
                                          />
                                        </Link>
                                        <div className="friend-info ms-0 ms-md-3 mt-md-0 mt-2">
                                          <h5>
                                            {
                                              chat?.participants?.data[1]
                                                ?.username
                                            }
                                          </h5>
                                          {/* <p className="mb-0">Today</p> */}
                                        </div>
                                      </div>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => chatview("Igchat")}
                                      >
                                        view chat
                                      </button>
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane
                      eventKey="facebook"
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      <Card>
                        <Card.Header className="d-flex justify-content-between rounded border-bottom-0">
                          <div className="header-title">
                            <h4 className="card-title">facebook</h4>
                          </div>
                        </Card.Header>
                      </Card>

                      <Row>
                        {Fbconversations?.map((chat) => {
                          return (
                            <Col lg="6" md="12">
                              <Card>
                                <Card.Body>
                                  <div className="iq-birthday-block">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <Link to="#">
                                          <img
                                            src={user5}
                                            alt="profile-img"
                                            className="img-fluid"
                                          />
                                        </Link>
                                        <div className="friend-info ms-0 ms-md-3 mt-md-0 mt-2">
                                          <h5>
                                            {chat.participants?.data[0]?.name}
                                          </h5>
                                          {/* <p className="mb-0">Today</p> */}
                                        </div>
                                      </div>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => chatview("fbchat")}
                                      >
                                        view chat
                                      </button>
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane
                      eventKey="whatsapp"
                      id="pills-contact"
                      role="tabpanel"
                      aria-labelledby="pills-contact-tab"
                    >
                      <Card>
                        <Card.Header className="d-flex justify-content-between rounded border-bottom-0">
                          <div className="header-title">
                            <h4 className="card-title">whatsapp</h4>
                          </div>
                        </Card.Header>
                      </Card>

                      <Row>
                        {Wpconversations?.map((chat) => {
                          return (
                            <Col lg="6" md="12">
                              <Card>
                                <Card.Body>
                                  <div className="iq-birthday-block">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <Link to="#">
                                          <img
                                            src={user5}
                                            alt="profile-img"
                                            className="img-fluid"
                                          />
                                        </Link>
                                        <div className="friend-info ms-0 ms-md-3 mt-md-0 mt-2">
                                          <h5>{chat?.name}</h5>
                                          {/* <p className="mb-0">Today</p> */}
                                        </div>
                                      </div>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => chatview("wpchat")}
                                      >
                                        view chat
                                      </button>
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          );
                        })}
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default Friendlist;
